import setCurrentView from 'modules/App/factories/setCurrentView'

export default [setCurrentView({ view: 'upload', showSort: false })]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/showUploadPanel.js